// extracted by mini-css-extract-plugin
export default {"overlay":"JG-z","bodyOpen":"KG-z","content":"LG-z","header":"MG-z","close":"NG-z","closeNoHeading":"OG-z"};